import React from "react";
import { Clock3, RefreshCw, ShieldCheck } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { formatDateTime } from "../lib/utils";

export const QrCodeCard = ({ tokenData, title, description, onRefresh, refreshing }) => {
  if (!tokenData) {
    return (
      <div className="rounded-3xl border border-dashed border-[#CBD5E1] bg-[#F8FAFC] p-6 text-sm text-[#64748B]">
        Generate a secure QR code when you are ready to verify handover.
      </div>
    );
  }

  return (
    <div className="rounded-3xl border border-[#E2E8F0] bg-white p-5 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[#B78A2A]">Secure handover</p>
          <h3 className="mt-1 font-['Manrope'] text-xl font-semibold text-[#0F172A]">{title}</h3>
          <p className="mt-2 max-w-xl text-sm leading-6 text-[#64748B]">{description}</p>
        </div>
        <button
          onClick={onRefresh}
          disabled={refreshing}
          className="inline-flex items-center gap-2 rounded-xl border border-[#E2E8F0] px-3 py-2 text-sm font-medium text-[#0F172A] disabled:opacity-60"
        >
          <RefreshCw size={14} className={refreshing ? "animate-spin" : ""} />
          Refresh code
        </button>
      </div>

      <div className="mt-5 grid gap-6 lg:grid-cols-[260px_1fr] lg:items-center">
        <div className="rounded-[28px] border border-[#E2E8F0] bg-[#F8FAFC] p-5 text-center">
          <div className="mx-auto inline-flex rounded-[24px] bg-white p-4 shadow-sm">
            <QRCodeSVG value={tokenData.token} size={180} includeMargin />
          </div>
          <p className="mt-4 text-sm font-medium text-[#0F172A]">Verification code</p>
          <p className="mt-1 break-all rounded-2xl bg-white px-3 py-2 text-xs text-[#475569] shadow-sm">{tokenData.token}</p>
        </div>

        <div className="space-y-4">
          <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
            <div className="flex items-start gap-3">
              <ShieldCheck size={18} className="mt-0.5" />
              <div>
                <p className="font-semibold">Trip-linked and time-limited</p>
                <p className="mt-1 leading-6">This QR code only works for the active trip and expires automatically to protect safeguarding records.</p>
              </div>
            </div>
          </div>
          <div className="rounded-2xl border border-[#E2E8F0] bg-[#F8FAFC] p-4 text-sm text-[#475569]">
            <div className="flex items-center gap-2 font-medium text-[#0F172A]">
              <Clock3 size={15} />
              Expires {formatDateTime(tokenData.expires_at)}
            </div>
            <p className="mt-2 leading-6">Flow: {tokenData.flow?.replace(/_/g, " ")}. If camera scanning is unavailable, the confirmation code above can be entered manually.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrCodeCard;
